// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__bXa6D","spinner":"Loader_spinner__mStzR","text":"Loader_text__0JD5H"};